<template>
    <div class="open-block">
        <div class="open-block__header text_13_s" :class="{ is_open: isOpen }" @click="toggle($event)">
            {{ q }}
        </div>
        <div class="open-block__body" :style="`height: ${height}px`">
            <div class="open-block__content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "OpenBlock",
    props: ["q"],
    data() {
        return {
            isOpen: false,
            height: 0,
        };
    },
    methods: {
        toggle(event) {
            this.isOpen = !this.isOpen;
            this.height = this.isOpen ? event.target.nextElementSibling.firstChild.offsetHeight : 0;
        },
    },
};
</script>
<style lang="less">
.open-block {
    border: 1px solid @border2;
    padding: 0 28px;
    margin-bottom: -1px;
    &__header {
        display: flex;
        cursor: pointer;
        padding: 16px 0;
        user-select: none;
        .trs(color);
        &:hover {
            color: @accent;
        }
        &:before {
            content: "+";
            margin-right: 27px;
            width: 9px;
            height: 15px;
            display: block;
        }
        &.is_open {
            &:before {
                content: "-";
                margin-right: 27px;
            }
        }
    }
    &__body {
        .trs(height);
        overflow: hidden;
    }
    &__content {
        padding: 16px 0;
        padding-left: 35px;
        border-top: 1px solid @border2;
        h5,
        h6 {
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 140%;
        }
        h6 {
            margin-bottom: 16px;
        }
        p,
        ul {
            font-style: normal;
            font-weight: normal;
            font-size: 13px;
            line-height: 140%;
            color: #7b7b7b;
        }
        p {
            margin-bottom: 10px;
        }
        ul {
            li {
                margin-bottom: 10px;
            }
        }
        &--h5 {
            margin-bottom: 40px;
        }
    }
}
</style>
